export default {
  writingTime: 0,
  downloadTime: 1000 * 30,
  timerIntervalId: null,
  timerIntervalTerm: 1000,
  meetingNoteList: [],
}
